module.exports = {
      id: "refresh-icon-usage",
      viewBox: "0 0 18 18",
      url: "/" + "sprite-79b777a110ad18271a4fc79289e4208e.svg#refresh-icon",
      toString: function () {
        return this.url;
      }
    }